import { inject } from '@angular/core';
import { RedirectFunction, Router } from '@angular/router';

/**
 * Settings and Account pick their section from a matrix param (/settings;section=greeting).
 * People and browser agents often try /settings/greeting, so send that to the real URL.
 */
export function redirectToSection(basePath: string): RedirectFunction {
  return ({ params, queryParams }) =>
    inject(Router).createUrlTree([basePath, { section: params['section'] }], { queryParams });
}

/** Returns null for a value that is not a section, so that the caller can use its default. */
export function toKnownSection<T extends string>(section: string | null, sections: Record<string, T>): T | null {
  return Object.values(sections).includes(section as T) ? (section as T) : null;
}
